import {
  ChangeStatusButton,
  DeleteButton,
  EditButton,
} from "@/components/IconButton/variants";
import { STATUS } from "@/constant/statusConstants";
import PropTypes from "prop-types";
import React from "react";

function Actions({
  row,
  handleOnClickDelete = false,
  handleOnChangeStatus = false,
  handleOnClickEdit = false,
}) {
  return (
    <div className="w-auto flex gap-x-1 justify-center">
      {handleOnChangeStatus && (
        <ChangeStatusButton
          isActive={row.original.status === STATUS.ACTIVE}
          onClick={() => handleOnChangeStatus(row.original)}
        />
      )}
      {handleOnClickEdit && (
        <EditButton onClick={() => handleOnClickEdit(row.original)} />
      )}
      {handleOnClickDelete && (
        <DeleteButton onClick={() => handleOnClickDelete(row.original)} />
      )}
    </div>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
  handleOnClickDelete: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  handleOnChangeStatus: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  handleOnClickEdit: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
};

export default React.memo(Actions);
